module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-full-height",
    on: {
      "click": function($event) {
        return _vm.closeClaimDropdown()
      }
    }
  }, [(_vm.ie) ? _c('div', {
    staticClass: "ie-detection-container"
  }, [_c('div', {
    staticClass: "ie-detection"
  }, [_c('div', {
    staticClass: "ie-detection-text"
  }, [_vm._v("It looks like you are currently using Internet Explorer " + _vm._s(_vm.ieVersion) + ". This website works best in "), _c('a', {
    attrs: {
      "href": "https://www.google.com/chrome/browser/desktop/index.html",
      "target": "_blank"
    }
  }, [_vm._v("Chrome")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "https://www.mozilla.org/en-GB/firefox/new/",
      "target": "_blank"
    }
  }, [_vm._v("Firefox")]), _vm._v(". Please consider switching for an improved experience.")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.hideWarningIE
    }
  }, [_vm._v("Continue in Internet Explorer " + _vm._s(_vm.ieVersion))])])]) : _vm._e(), _vm._v(" "), _c('passport'), _vm._v(" "), _c('navigation'), _vm._v(" "), _c('right-col'), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "error_modal",
      "no-default-button": "true"
    }
  }, [_c('h1', [_vm._v("\n            Something has gone wrong!\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            We're sorry, there has been a problem with your request."), _c('br'), _c('br'), _vm._v("\n            Rest assured, the BC Legal Development Team has been notified\n            of this issue and will investigate and resolve this as soon as possible.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            If you would like to escalate the issue for immediate attention,\n            please contact "), _c('a', {
    attrs: {
      "href": "mailto:developers@bc-legal.co.uk"
    }
  }, [_vm._v("developers@bc-legal.co.uk")]), _vm._v("\n            explaining the issue"), (!_vm.errorToDisplay.exception) ? _c('span', [_vm._v(".")]) : _c('span', [_vm._v(" and including the error message below:")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errorToDisplay.exception) ? _c('div', {
    staticStyle: {
      "margin-left": "40px",
      "border-left": "5px solid #ccc",
      "padding-left": "40px",
      "padding-bottom": "20px",
      "padding-top": "20px"
    }
  }, [_c('strong', [_c('pre', [_vm._v(_vm._s(_vm.errorToDisplay.exception) + " - " + _vm._s(_vm.errorToDisplay.url))])]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.errorToDisplay.message))])]) : _vm._e()]), _vm._v(" "), _c('modal', {
    style: (_vm.heartbeatLoggedOut ? 'display: block' : ''),
    attrs: {
      "name": "loggedout_modal",
      "no-default-button": "true"
    }
  }, [_c('h1', [_vm._v("You have been logged out")]), _vm._v(" "), _c('div', {
    staticClass: "o-modal__exception-body"
  }, [_c('pre', [_vm._v("Please log back in to continue")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bd26cd6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1798
// module chunks = 0